// Вкладка «Новости» (Figma «Раздел новостей»): шапки нет (headers.news.visible: false), экран начинается полосой
// вкладок из tab_bar хаба (newsTabs.ts: main · videos · topic:<slug>, адреса как есть) — Tab 772:30723: 120 × 42, листаются.
// Нет ответа хаба (загрузка, ошибка, нет сети — Figma 772:30737): полоса из известных вкладок (knownNewsTabBar), под ней
// ErrorView в области «Главного»; вкладки «Видео» и тем ответа хаба не ждут. Вкладки неизвестны — только QueryFallback.
// «Главное» — секции по sections_order, у каждой «Все» → more_path.
// Общая секция (без entity — не лента федерации/турнира) — с фиолетовым значком «тренд», как «Главное» в Figma.
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import type { NewsHub } from '../../api/leagueTypes';
import { knownNewsTabBar, useNewsHub } from '../../api/newsQueries';
import { t } from '../../i18n/i18n';
import { NewsArticlesBlock } from '../../ui/NewsCardView';
import { adsForSection } from '../../ui/newsAds';
import { MaskIcon } from '../../ui/MenuCell';
import { ServerTabStrip } from '../../ui/ServerTabStrip';
import trendIcon from '../../assets/icons/trend-up.svg';
import { QueryFallback } from '../../ui/States';
import { Placeholder } from '../Placeholder';
import { activeNewsTab, newsTabs } from './newsTabs';
import { GUTTER_8, NewsFeedList } from './NewsFeedScreen';
import { VideosContent } from './VideosScreen';
import styles from './News.module.css';


let remembered: string | null = null; // выбранная вкладка переживает уход на статью и назад

export function NewsHubScreen({ path }: { path: string }) {
  const [tab, setTab] = useState(remembered);
  const query = useNewsHub(path);
  const hub = query.data;
  const tabBar = hub ? hub.tab_bar : knownNewsTabBar(path);
  if (!hub && !tabBar) return <>{GUTTER_8}<QueryFallback query={query} /></>;
  const tabs = newsTabs(hub ?? { tab_bar: tabBar });
  const active = activeNewsTab(tabs, tabBar?.default_key, tab);
  const current = tabs.find((x) => x.key === active)!;
  const select = (key: string) => { remembered = key; setTab(key); window.scrollTo(0, 0); };
  return (
    <div className={styles.white}>
      {GUTTER_8}
      <div className={styles.strip}><ServerTabStrip tabs={tabs} active={active} onSelect={select} tabWidth={120} /></div>
      {current.kind === 'main' && (hub ? <Sections hub={hub} /> : <QueryFallback query={query} compact />)}
      {current.kind === 'videos' && <VideosContent league={null} path={current.endpoint} />}
      {current.kind === 'topic' && <NewsFeedList key={current.key} path={current.endpoint} />}
    </div>
  );
}

function Sections({ hub }: { hub: NewsHub }) {
  const navigate = useNavigate();
  const sections = hub.sections_order.map((k) => hub.sections.find((s) => s.key === k)).filter((s) => s && s.articles.length);
  if (!sections.length) return <Placeholder title={t('mc_news_empty')} text={t('tg_news_soon')} />;
  return (
    <div className={styles.list}>
      {sections.map((s) => (
        <section key={s!.key} className={styles.section}>
          <header className={styles.sectionHeader}>
            {!s!.entity && <span className={styles.sectionIcon}><MaskIcon src={trendIcon} size={14} /></span>}
            <h2 className={styles.sectionTitle}>{s!.title}</h2>
            {s!.more_path && (
              <button className={styles.all} onClick={() => navigate('/feed', { state: { path: s!.more_path, title: s!.title } })}>
                {t('mc_all')}
              </button>
            )}
          </header>
          <NewsArticlesBlock articles={s!.articles} ads={adsForSection(hub.ads, s!.key)} place="news_hub" />
        </section>
      ))}
    </div>
  );
}
